import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const sectionStyles: SxProps<Theme> = {
    mt: 3,
};

export const cardStyles: SxProps<Theme> = {
    p: 3,
    mb: 3,
};

export const cardTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    mb: 0.5,
};

export const cardHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2.5,
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
};

/**
 * The line beside a disabled Save that says why it is disabled. Modelled on the
 * count-of-problems hint the About and Our Services editors already show.
 */
export const blockedSaveStyles: SxProps<Theme> = {
    color: 'error.main',
    alignSelf: 'center',
    mr: 2,
};

